import type { RouteLocation } from 'vue-router'

export default function useCurrentURL(
  currentRoute: Pick<RouteLocation, 'fullPath'> = useRoute(),
) {
  return computed(() => new URL(currentRoute.fullPath, useRequestURL().origin))
}
